import { animated, easings, useSpring } from '@react-spring/web';
import { useRef } from 'react';

import { CardImg } from '@sorare/core/src/components/card/CardImg';

import { useLatest } from 'react-use';
import { collectionAnimationConfig } from '#src/components/commonCard/RevealPackCardsDialog/CollectionAnimation/animationConfig.ts';

type Props = {
  cardPictureUrl: string;
  shouldAnimate: boolean;
  onAnimationEnd: () => void;
};

export const AnimatingSlot = ({
  cardPictureUrl,
  shouldAnimate,
  onAnimationEnd,
}: Props) => {
  const onAnimationEndCalled = useRef(false);

  const latestOnAnimationEnd = useLatest(onAnimationEnd);
  const styles = useSpring({
    from: {
      opacity: 0,
      scale: 1.3,
      brightness: 1,
    },
    to: [
      {
        opacity: 1,
        scale: 1,
        brightness: 1.2,
      },
      {
        opacity: 1,
        scale: 1,
        brightness: 1,
      },
    ],
    config: {
      duration: collectionAnimationConfig.cardEnterDurationMs,
      easing: easings.easeOutCubic,
    },
    pause: !shouldAnimate,
    onRest: ({ finished }) => {
      if (
        finished &&
        // prevent calling onAnimationEnd multiple times
        // as it happens when to is an array
        !onAnimationEndCalled.current
      ) {
        onAnimationEndCalled.current = true;
        // use latest onAnimationEnd to avoid stale callback
        latestOnAnimationEnd.current();
      }
    },
  });

  return (
    <animated.div
      style={{
        opacity: styles.opacity,
        scale: styles.scale,
        filter: styles.brightness.to(brightness => `brightness(${brightness})`),
      }}
    >
      <CardImg src={cardPictureUrl} width={160} />
    </animated.div>
  );
};
